module.exports = window["MaterialUI"].DialogContent;